t<template>
  <div class="calculator-wrapper">
    <div class="calculator">
      <CalculatorHeading :step="step"></CalculatorHeading>
      <ApproveInput
        question="Do you want to access your home remotely?"
        :image="require('@/assets/remote-access.svg')"
        :selected-value="remoteAccess"
        :clicked-callback="onSelect"
      ></ApproveInput>
      <a @click="$router.push(getPrevStepUrl(step))" class="back-btn"
        >{{ $t('back') }}</a
      >
    </div>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
import ApproveInput from "../../components/ApproveInput";
import CalculatorHeading from "../../components/CalculatorHeading";
import { getStepIndex, redirectToUnselectedStepIfAny, getPrevStepUrl, getNextStepUrl } from "@/utils/steps.js";

export default {
  name: "VoiceControl",
  components: { CalculatorHeading, ApproveInput },
  data() {
    return {
      step: getStepIndex("remote-access"),
      getPrevStepUrl: getPrevStepUrl,
      remoteAccess: this.$store.state.data.remoteAccess
    };
  },
  mounted() {
    redirectToUnselectedStepIfAny(
      this.step,
      this.$store.state.data,
      this.$router,
      this.$i18n.locale
    );
  },
  methods: {
    ...mapMutations(["updateRemoteAccess"]),
    onSelect(value) {
      this.remoteAccess = value;
      this.updateRemoteAccess(value);
      setTimeout(() => this.$router.push(getNextStepUrl(this.step, this.$i18n.locale)), 200);
    }
  }
};
</script>
